import createIcon from '../../createIcon';

/**
 * @component @name BluetoothDrive
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTFINC44MUw1Ljg1IDhIMTVWNkg1LjVDNC44NCA2IDQuMjkgNi40MiA0LjA4IDcuMDFMMiAxM1YyMUMyIDIxLjU1IDIuNDUgMjIgMyAyMkg0QzQuNTUgMjIgNSAyMS41NSA1IDIxVjIwSDE3VjIxQzE3IDIxLjU1IDE3LjQ1IDIyIDE4IDIySDE5QzE5LjU1IDIyIDIwIDIxLjU1IDIwIDIxVjEzSDE3QzE1LjkgMTMgMTUgMTIuMSAxNSAxMVpNNi41IDE3QzUuNjcgMTcgNSAxNi4zMyA1IDE1LjVDNSAxNC42NyA1LjY3IDE0IDYuNSAxNEM3LjMzIDE0IDggMTQuNjcgOCAxNS41QzggMTYuMzMgNy4zMyAxNyA2LjUgMTdaTTE1LjUgMTdDMTQuNjcgMTcgMTQgMTYuMzMgMTQgMTUuNUMxNCAxNC42NyAxNC42NyAxNCAxNS41IDE0QzE2LjMzIDE0IDE3IDE0LjY3IDE3IDE1LjVDMTcgMTYuMzMgMTYuMzMgMTcgMTUuNSAxN1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMiA0Ljg1TDE5LjE1IDJIMTguNjVWNS43OUwxNi4zNSAzLjVMMTUuNjUgNC4yTDE4LjQ0IDdMMTUuNjUgOS43OUwxNi4zNSAxMC41TDE4LjY1IDguMlYxMkgxOS4xNUwyMiA5LjE0TDE5Ljg1IDdMMjIgNC44NVpNMTkuNjUgMy45MUwyMC41OSA0Ljg1TDE5LjY1IDUuNzlWMy45MVpNMjAuNTkgOS4xNEwxOS42NSAxMC4wOFY4LjJMMjAuNTkgOS4xNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BluetoothDrive = createIcon('BluetoothDrive', [
  [
    'path',
    {
      d: 'M15 11H4.81L5.85 8H15V6H5.5C4.84 6 4.29 6.42 4.08 7.01L2 13V21C2 21.55 2.45 22 3 22H4C4.55 22 5 21.55 5 21V20H17V21C17 21.55 17.45 22 18 22H19C19.55 22 20 21.55 20 21V13H17C15.9 13 15 12.1 15 11ZM6.5 17C5.67 17 5 16.33 5 15.5C5 14.67 5.67 14 6.5 14C7.33 14 8 14.67 8 15.5C8 16.33 7.33 17 6.5 17ZM15.5 17C14.67 17 14 16.33 14 15.5C14 14.67 14.67 14 15.5 14C16.33 14 17 14.67 17 15.5C17 16.33 16.33 17 15.5 17Z',
      key: '1mgqf8',
    },
  ],
  [
    'path',
    {
      d: 'M22 4.85L19.15 2H18.65V5.79L16.35 3.5L15.65 4.2L18.44 7L15.65 9.79L16.35 10.5L18.65 8.2V12H19.15L22 9.14L19.85 7L22 4.85ZM19.65 3.91L20.59 4.85L19.65 5.79V3.91ZM20.59 9.14L19.65 10.08V8.2L20.59 9.14Z',
      key: 'v3aioa',
    },
  ],
]);

export default BluetoothDrive;
